import { Tag } from 'lucide-react';

export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className="flex items-center gap-3">
    <div className="flex size-10 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-[0_0_24px_color-mix(in_srgb,var(--primary)_18%,transparent)]"><Tag className="size-5" strokeWidth={2.2} /></div>
    {!compact ? <div><p className="text-base font-bold tracking-tight">Pricy<span className="text-primary">Mayky</span></p><p className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Ceny pod kontrolą</p></div> : null}
  </div>;
}
